/* ==========================================================================
   AURRA — mobile sticky Add to Cart bar
   ==========================================================================

   Deliberately NOT inline in the section. A script that throws inside a
   Liquid section can leave Shopify caching a broken render for hours, which
   has bitten this store before.

   The bar holds no state. It mirrors Dawn's real controls and delegates
   every click to Dawn's real submit button, so the variant, the AJAX add
   and the cart drawer all travel their normal path.
   ========================================================================== */
(function () {
  'use strict';

  try {
    var bar = document.querySelector('[data-aurra-satc]');
    if (!bar) return;

    var sectionId = bar.getAttribute('data-section-id');
    var realBtn = document.querySelector('.product-form__submit');
    var realPrice = document.getElementById('price-' + sectionId);
    var barBtn = bar.querySelector('[data-aurra-satc-btn]');
    var barLabel = bar.querySelector('[data-aurra-satc-label]');
    var barPrice = bar.querySelector('[data-aurra-satc-price]');

    if (!realBtn || !barBtn) return;

    /* ----------------------------------------------------------------
       Mirror the real button's label and disabled state.

       Dawn rewrites both when a variant goes out of stock, so watching
       it is always correct - there is no second source of truth here.
       ---------------------------------------------------------------- */
    function syncButton() {
      var disabled = realBtn.hasAttribute('disabled');
      barBtn.disabled = disabled;
      bar.classList.toggle('is-unavailable', disabled);

      var span = realBtn.querySelector('span');
      var text = span ? span.textContent.trim() : '';
      if (text) barLabel.textContent = text;
    }

    function syncPrice() {
      if (realPrice && barPrice) barPrice.innerHTML = realPrice.innerHTML;
    }

    syncButton();

    if (window.MutationObserver) {
      new MutationObserver(syncButton).observe(realBtn, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        subtree: true,
        characterData: true
      });

      if (realPrice) {
        new MutationObserver(syncPrice).observe(realPrice, {
          childList: true,
          subtree: true,
          characterData: true
        });
      }
    }

    /* ----------------------------------------------------------------
       Show the bar only while the real button is off screen, so the
       customer never sees two Add to Cart buttons competing.

       IntersectionObserver watches the real buttons; no scroll handler,
       nothing running per frame.
       ---------------------------------------------------------------- */
    var anchor = realBtn.closest('.product-form__buttons') || realBtn;

    function reveal(show) {
      if (show) {
        bar.removeAttribute('hidden');
        /* Force a reflow so the browser records the off-screen transform as
           the transition's starting state. requestAnimationFrame would read
           better, but rAF is throttled to nothing in a background tab, and
           the bar would then never get its class at all. This is synchronous
           and cannot be starved. */
        void bar.offsetHeight;
        bar.classList.add('is-visible');
        document.documentElement.classList.add('aurra-satc-on');
      } else {
        bar.classList.remove('is-visible');
        document.documentElement.classList.remove('aurra-satc-on');
      }
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        reveal(!entries[0].isIntersecting);
      }, { threshold: 0.1 }).observe(anchor);
    } else {
      reveal(true);
    }

    /* ----------------------------------------------------------------
       Delegate. Not a form submit of our own - Dawn binds its handler to
       the form and manages the spinner and error message on the real
       button, so the real button is what must be clicked.
       ---------------------------------------------------------------- */
    barBtn.addEventListener('click', function () {
      if (barBtn.disabled) return;
      realBtn.click();
    });

    /* Hide behind the cart drawer rather than floating over it. */
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () {
        bar.classList.toggle('is-behind', drawer.classList.contains('active'));
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  } catch (e) {
    if (window.console && console.warn) console.warn('[aurra-sticky-atc]', e);
  }
})();
